import { Button, Card } from "react-bootstrap"
import { formatAddress, googleAddress } from "../../Helpers/Property/propertyAddressFormatters"
import './propertyEntry.scss'
import timeService from "../../services/time/timeService"
import AccessLinkButton from "../Buttons/AccessLinkButton"
import { PropertyType } from "../../Types/propertyTypes"
import { API_URL, FRONTEND_URL } from "../../Config/config"
import canAccess from "../../services/accessService/accessService"
import ReconcilePropertyButton from "./ReconcilePropertyButton"
import RemoteLockControls from "./RemoteLockControls"
import { Link } from "react-router-dom"

export const PropertyEntry = (props: any) => {
  const {
    propertyInfo,
    details = false,
    disableLinks = {},
    extraButtons = []
  } = props

  const {
    _id,
    title,
    address,
  } = propertyInfo

  const startOfToday = timeService.createLuxonDate(new Date()).startOf('day').toMillis()

  let usingBlocks = false
  if (propertyInfo?.linkedServices && propertyInfo.linkedServices.length > 0) {
    const blocksService = propertyInfo.linkedServices.find((service: any) => service.linkedService === 'blockingProperty')
    if (blocksService) {
      usingBlocks = true
    }
  }

  return (
    <Card className="property-entry">
      {/* <Card.Header>
        <b>{title}</b>
      </Card.Header> */}
      <Card.Body>
        <Card.Title>
          <b>{title}</b>
        </Card.Title>
        {address && (
          <Card.Link
            className={`small text-decoration-none`}
            href={`${googleAddress(address)}`}
            target="_blank">
            {formatAddress(address)}
          </Card.Link>
        )}

        {/* {propertyInfo.coordinates && propertyInfo.coordinates.length === 2 && (
          <div>
            {`(Lat: ${propertyInfo.coordinates[1]}, Lng: ${propertyInfo.coordinates[0]})`}
          </div>
        )} */}

        {details && (
          <PropertyInfo {...propertyInfo} />
        )}


      </Card.Body>
      <Card.Footer>
        {!disableLinks['view'] && (
          <AccessLinkButton
            action={'property'}
            text={'View'}
            size={'sm'}
            to={`/property/${_id}`}
          />
        )}

        <AccessLinkButton
          action={'ical-data'}
          color={'success'}
          size={'sm'}
          text={'Ical'}
          to={`/property/ical-data/${_id}`}
        />

        <AccessLinkButton
          action={'financials-property'}
          color={'success'}
          size={'sm'}
          text={'Financials'}
          to={`/financials-property/${_id}`}
        />

        {/* handle property prices link */}
        <AccessLinkButton
          action={'handle-property-prices'}
          color={'success'}
          size={'sm'}
          text={'Pricing'}
          to={`/handle-property-prices/${_id}`}
        />

        <AccessLinkButton
          action={'inventory-check'}
          color={'secondary'}
          size={'sm'}
          text={'Inventory'}
          to={`/inventory-check/${_id}`}
        />

        <AccessLinkButton
          action={'property-bookings'}
          color={'secondary'}
          size={'sm'}
          text={'Bookings'}
          to={`/bookings?query={"propertyId":"${_id}","checkIn":${startOfToday},"bookingStatus":["new","pending","confirmed","request"]}`}
        />

        <AccessLinkButton
          action={'property-tasks'}
          color={'secondary'}
          size={'sm'}
          text={'Tasks'}
          to={`/property-tasks?query={"propertyId":"${_id}"}`}
        />

        {/* add booking link */}
        <AccessLinkButton
          action={'add-booking'}
          color={'dark'}
          size={'sm'}
          text={'Booking⚡'}
          to={`/add-booking?query={"propertyId":"${_id}", "quickBooking":1}`}
        />

        <AccessLinkButton
          action={'full-add-booking'}
          color={'dark'}
          size={'sm'}
          text={'+ Booking'}
          to={`/add-booking?query={"propertyId":"${_id}"}`}
        />

        {/* add task link */}
        <AccessLinkButton
          action={'add-task'}
          color={'dark'}
          size={'sm'}
          text={'+ Task'}
          to={`/add-property-task?query={"propertyId":"${_id}"}`}
        />

        {usingBlocks && (
          <AccessLinkButton
            action={'date-blocks'}
            color={'warning'}
            size={'sm'}
            text={'Blocks'}
            to={`/date-blocks?query={"propertyId":"${_id}", "checkIn":${startOfToday}}`}
          />
        )}

        {propertyInfo?.services?.cleaning && (
          <AccessLinkButton
            action={'turnovers'}
            color={'info'}
            size={'sm'}
            text={'Turnovers'}
            to={`/turnovers?query={"propertyId":"${_id}"}`}
          />
        )}

        <AccessLinkButton
          action={'edit-property'}
          color={'secondary'}
          size={'sm'}
          text={'Edit'}
          to={`/edit-property/${_id}`}
        />

        {/* <AccessLinkButton
          action={'delete-property'}
          color={'danger'}
          size={'sm'}
          text={'Delete'}
          to={`/delete-property/${_id}`}
        /> */}

        {extraButtons && extraButtons.map((button: any, index: number) => (
          <Button
            key={index}
            className="me-1 mb-1"
            size={'sm'}
            variant={button.variant ? button.variant : 'secondary'}
            disabled={button.disabled}
            onClick={() => button.onClick(propertyInfo)}>
            {button.label}
          </Button>
        ))}

      </Card.Footer>
    </Card>
  )
}


export const PropertyInfo = (props: PropertyType) => {
  const {
    _id,
    created,
    // title,
    // description,
    // featuredImage,
    multiUnit,
    listed,
    linkedServices,
    coordinates,
    about } = props

  let remoteLockPayload: {
    deviceId?: string,
    deviceName?: string,
    deviceType?: string,
  } = {}

  if (linkedServices && linkedServices.length > 0) {
    const remoteLock = linkedServices.find((service: any) => service.linkedService === 'remoteLock')
    if (remoteLock) {
      remoteLockPayload = JSON.parse(remoteLock.linkedServiceId)
      if (!remoteLockPayload.deviceType) {
        remoteLockPayload.deviceType = 'locks'
      }
    }
  }

  return (
    <div>

      {(coordinates && coordinates.length === 2) ? (
        <div>
          {`(Lat: ${coordinates[1]}, Lng: ${coordinates[0]})`}
        </div>
      ) : (
        <div className="text-danger">
          Please Add Coordinates
        </div>
      )}

      <hr />

      {/* <h2>{title}</h2> */}

      {/* <p className="fst-italic text-break">
        {description}
      </p> */}


      Property ID: {_id} <br />
      Building ID: {props.buildingId ? (
        <Link to={`/building/${props.buildingId}`}>
          {props.buildingId}
        </Link>
      ) : 'No Building Assigned'}
      {created && (<>
        <br />
        Created: {timeService.getFormattedTime(new Date(created))}
      </>)}
      <br />
      Web Link: &nbsp;
      <a target="_blank" href={`${FRONTEND_URL}/property/${_id}`} rel="noreferrer">
        {`${FRONTEND_URL}/property/${_id}`}
      </a>

      {about?.guestInstructions?.find(s => s.sectionId === 'internet') && (
        <div className="my-3 p-2 border rounded bg-light">
          <b>{about.guestInstructions.find(s => s.sectionId === 'internet')!.sectionTitle || 'Internet'}</b>
          <br />
          <span style={{ whiteSpace: 'pre-line' }}>
            {about.guestInstructions.find(s => s.sectionId === 'internet')!.content}
          </span>
        </div>
      )}

      <PropertyListedList listed={listed} className="mb-4" />

      <RemoteLockControls remoteLockPayload={remoteLockPayload} />

      <b>Icalendars</b>
      <br />
      Ical Link: &nbsp;
      <a target="_blank" href={`${API_URL}/icalendar/property/${_id}.ics`} rel="noreferrer">
        {`${API_URL}/icalendar/property/${_id}.ics`}
      </a>
      <br />

      {multiUnit?.isMultiUnit && (
        <>
          MULTI Ical Link: &nbsp;
          <a target="_blank" href={`${API_URL}/icalendar/property-multi/${_id}.ics`} rel="noreferrer">
            {`${API_URL}/icalendar/property-multi/${_id}.ics`}
          </a>
          <br />
        </>
      )}

      {canAccess('property', 'reconcile-property') && (
        <div className="my-2">
          <ReconcilePropertyButton propertyId={_id} />
        </div>
      )}

      {/* <br />
      <img className="property-img" src={featuredImage} alt={title} /> */}
      <br />
    </div>
  )
}

export const PropertyListedList = (props: {
  listed: {
    source: string,
    url: string,
    internalId?: string,
  }[]
  className?: string
}) => {
  const {
    listed,
    className
  } = props

  if (!listed || listed.length === 0) {
    return null
  }

  return (
    <div className={className}>
      <b>Online Listings</b>
      <div>
        {listed.map((listing, i) => {

          let editLink = ''
          let calendarLink: string = ''
          let inboxLink: string = ''

          if (listing.source === 'airbnb' && canAccess('property', 'edit-airbnb')) {
            calendarLink = listing.url.replace('rooms', 'multicalendar')
            const airbnbId = listing.url.split('/').pop()
            editLink = `https://www.airbnb.com/hosting/listings/editor/${airbnbId}`
          }

          if (listing.source === 'homeaway' && listing.internalId && canAccess('property', 'edit-vrbo')) {
            // https://www.vrbo.com/supply/inbox?propertyId=111028056
            inboxLink = `https://www.vrbo.com/supply/inbox?propertyId=${listing.internalId}`
          }

          let listingUrl = listing.url
          if (listing.source === 'homeaway') {
            listingUrl += '?dateless=true'
          }

          return (
            <div key={i}>
              {listing.source}:  <a target="_blank" href={listingUrl} rel="noreferrer">
                {listingUrl}
              </a>&nbsp;
              {editLink && (
                <a className="text-decoration-none" target="_blank" href={editLink} rel="noreferrer" title="Edit Listing">
                  ✏️
                </a>
              )}
              {calendarLink && (
                <>
                  &nbsp;
                  <a className="text-decoration-none" target="_blank" href={calendarLink} rel="noreferrer">
                    📅
                  </a>
                </>
              )}
              {inboxLink && (
                <>
                  &nbsp;
                  <a className="text-decoration-none" target="_blank" href={inboxLink} rel="noreferrer">
                    📥
                  </a>
                </>
              )}



            </div>
          )
        })}
      </div>
    </div>
  )
}